export const isLoadingProcessor = state => ({
	...state,
	isLoading: true
});

export const isNotLoadingProcessor = state => ({
	...state,
	isLoading: false
});